<template>
  <nuxt-layout name="blank">
    <div class="flex items-center justify-center h-screen text-white">
      <div v-if="props.error">
        <h1 class="text-center text-5xl">{{ props.error.statusCode }}</h1>
        <NuxtLink to="/" class="text-white underline" v-if="props.error.statusCode === 404">{{ $t('error.go_back_home') }}</NuxtLink>
      </div>
    </div>
  </nuxt-layout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError
})
</script>
